/**
 * reviewOutputTypes — ParsedOutput type and parser for AI-generated review text.
 * Kept in a separate .ts file so AIReviewTabHelpers.tsx can be components-only
 * (required for Vite Fast Refresh).
 */

export interface ParsedOutput {
  quality: string;
  deliverables: string;
  /** Q4 Leadership Values text; '' when Q4 does not apply (or for a review generated before Q4). */
  leadership?: string;
  behaviors: string;
  /** Q13 calibration summary (not visible to the employee); '' for a review generated before Q13. */
  calibration?: string;
}

/** Field markers in the model's answer. FIELD 5 is the behaviors text (Culture Amp Q11). */
export const FIELD_MARKERS = {
  deliverables: '### FIELD 3:',
  leadership: '### FIELD 4:',
  behaviors: '### FIELD 5:',
  calibration: '### FIELD 13:',
} as const;

export function parseOutput(raw: string): ParsedOutput {
  // Text after `start`, up to the earliest of the `ends` that follows it.
  const get = (start: string, ...ends: string[]) => {
    const i = raw.indexOf(start);
    if (i === -1) return '';
    const after = raw.slice(i + start.length);
    const cut = ends.map(e => after.indexOf(e)).filter(j => j !== -1);
    return (cut.length ? after.slice(0, Math.min(...cut)) : after).trim();
  };
  return {
    quality:      get('## SECTION 1:', '## SECTION 2:'),
    deliverables: get(FIELD_MARKERS.deliverables, FIELD_MARKERS.leadership, FIELD_MARKERS.behaviors),
    leadership:   get(FIELD_MARKERS.leadership, FIELD_MARKERS.behaviors),
    behaviors:    get(FIELD_MARKERS.behaviors, FIELD_MARKERS.calibration),
    calibration:  get(FIELD_MARKERS.calibration),
  };
}
